// extracted by mini-css-extract-plugin
export default {"headerPanel":"header-panel_headerPanel__NtdTX","panel":"header-panel_panel__85v2f"};